import React, { FC } from "react";

import { ReactComponent as SvgShield } from "@shared/assets/icons/shield.svg";
import { ModalCardTitle } from "@shared/aviary/bloomer";

import "./TwoFactorTitle.scss";

interface Props {
  title: string;
}

const TwoFactorTitle: FC<Props> = ({ title }) => {
  return (
    <ModalCardTitle className="text-center">
      <SvgShield className="two-factor-icon" />
      {title}
    </ModalCardTitle>
  );
};

export { TwoFactorTitle };
